import { useEffect, useMemo } from "react";
import { Form, Row, Col, Input, Button, Space, Select, DatePicker } from "antd";
import { AiOutlineSearch, AiOutlineClear } from "react-icons/ai";
import { BiRefresh } from "react-icons/bi";
import moment from "moment";
import OriginAndDestinationDropDown from "../DropdownComponent/DestinationDropdown";
import { TripDirection } from "../../TripPlanComponent/TripPlanTableNew";
import BusinessUnitDropDown from "../DropdownComponent/BusinessUnitDropdown";
import { SessionStorage } from "../../../services/storage";
import { IEmployee } from "../../../model/LoginModel";
import { isAllBusinessUser } from "../../../utils/User-constants";
import { useUserContextHook } from "../../../hooks/useUserContextHook";

const { RangePicker } = DatePicker;

export const tripPlanStatusList = [
  { label: "Open", value: "Open" },
  { label: "Cancelled", value: "Cancelled" },
  { label: "Closed", value: "Closed" },
  { label: "Load To Destination", value: "Load To Destination" },
  { label: "Offload At Transit", value: "Offload At Transit" },
  { label: "Load At Transit", value: "Load At Transit" },
  { label: "Arrived At Destination", value: "Arrived At Destination" },
];
const StylePlan = {
  margin: 0,
  padding: 2,
  paddingLeft: 8,
  minHeight: "65px",
  maxHeight: "85px",
  lineHeight: 1,
  marginBottom: "0px",
};

export const TripPlanFilterFilter = ({
  children,
  onSearch,
  onReset,
  refresh,
  initialValues,
  title = "Booking Filter",
  style = StylePlan,
}) => {
  const [form] = Form.useForm();
  const tripPlanNumber = Form.useWatch("tripPlanNumber", form);

    const { employeeDetail } = useUserContextHook();

    const businessId = employeeDetail?.businessId;


  const defaultIndustryTypeList = useMemo(() => {
    const id = Number(businessId);
    if (!id || id === 9) return undefined; // 9 = all business → no filter
    return [id];                            // 8 → [8], 2 → [2]
  }, [businessId]);



useEffect(() => {
  form.setFieldsValue({
    ...(initialValues || {}),
    startEndDate: initialValues?.startEndDate?.length
      ? [moment(initialValues.startEndDate[0]), moment(initialValues.startEndDate[1])]
      : [],
    pickupDate: initialValues?.pickupDate?.length
      ? [moment(initialValues.pickupDate[0]), moment(initialValues.pickupDate[1])]
      : [],
    industryTypeList: initialValues?.industryTypeList?.length
      ? initialValues.industryTypeList
      : defaultIndustryTypeList,
  });
}, [form, initialValues, defaultIndustryTypeList]);

  const filterReset = () => {
    onReset && onReset();
    form.resetFields();
    form.setFieldsValue({ industryTypeList: initialValues?.industryTypeList });
  };

  return (
    <>
      <div
        style={{
          minHeight: 24, // smaller height
          lineHeight: "24px", // vertically center text exactly
          fontWeight: 600,
          fontSize: 16,
          padding: 2,
          paddingLeft: 8,
          margin: 0,
          display: "flex",
        }}
      >
        {title}
        <Col style={{ whiteSpace: "nowrap", marginLeft: 14 }}>{children}</Col>
      </div>

      <Row justify="space-between" align="middle" style={style}>
        {/* Left: Form */}
        <Col flex="auto" style={{ minWidth: 0 }}>
          <Form
            name="filter"
            onFinish={onSearch}
            form={form}
            autoComplete="off"
            preserve={false}
            style={{ margin: 0, padding: 0 }}
            size="small"
          >
            <Row gutter={[8, 0]} justify="start" align="middle" wrap>
              <Col span={3}>
                <Form.Item
                  name={"tripPlanNumber"}
                  label={"Trip Plan Number"}
                  labelCol={{ span: 24 }}
                >
                  <Input
                    className="small-select"
                    allowClear
                    autoComplete={"off"}
                  />
                </Form.Item>
              </Col>
              <Col span={3}>
                <Form.Item
                  name="tripRoute"
                  label={"Trip Route"}
                  labelCol={{ span: 24 }}
                >
                  <Input
                    className="small-select"
                    allowClear
                    autoComplete={"off"}
                  />
                </Form.Item>
              </Col>
              <Col span={3}>
                <OriginAndDestinationDropDown
                  name="originList"
                  label="Origin"
                  isMultiple={true}
                  // required={!tripPlanNumber && initialValues?.tripDirection === TripDirection.Outgoing}
                  className="small-select"
                />
              </Col>
              <Col span={3}>
                <OriginAndDestinationDropDown
                  name="destinationList"
                  label="Destination"
                  isMultiple={true}
                  className="small-select"
                // required={!tripPlanNumber && initialValues?.tripDirection === TripDirection.Incoming}
                />
              </Col>
              <Col span={4}>
                <Form.Item
                  rules={[
                    {
                      required: !tripPlanNumber,
                      message: "Please select a date range",
                    },
                  ]}
                  name="startEndDate"
                  label="Created Date Range"
                  labelCol={{ span: 24 }}
                >
                  <RangePicker
                    allowClear
                    format="DD/MM/YYYY"
                    className="width_full"
                    style={{ fontSize: "12px" }}
                    size="small"
                    disabledDate={(current) =>
                      current && current > moment().endOf("day")
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={3}>
                <Form.Item
                  name={"tripPlanStatus"}
                  label={"Status"}
                  labelCol={{ span: 24 }}
                >
                  <Select
                    className="small-select"
                    showSearch={true}
                    allowClear={true}
                    filterOption={(input, option) =>
                      String(option?.children)
                        .toLocaleLowerCase()
                        .includes(input?.toLocaleLowerCase())
                    }
                  >
                    {tripPlanStatusList?.map((origin) => (
                      <Select.Option key={origin.label} value={origin.value}>
                        {origin.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={3}>
                <BusinessUnitDropDown
                  name="industryTypeList"
                  label="Business Unit"
                  disabled={!isAllBusinessUser()}
                />
              </Col>
              <Col>
                <Space
                  align="center"
                  size={4}
                  style={{ marginTop: 5, padding: 0 }}
                >
                  <Button
                    htmlType="submit"
                    icon={<AiOutlineSearch size={18} />}
                  />
                  <Button
                    htmlType="button"
                    onClick={filterReset}
                    icon={<AiOutlineClear size={18} />}
                  />
                  <Button
                    type="default"
                    onClick={refresh}
                    icon={<BiRefresh size={18} />}
                  />
                </Space>
              </Col>
            </Row>
          </Form>
        </Col>

        {/* Right: children */}
      </Row>
    </>
  );
};
